// extracted by mini-css-extract-plugin
module.exports = {"headerBox":"BannerPoster_style_headerBox__18k4q","banner":"BannerPoster_style_banner__AHAiX"};